import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { CoursePromotionState, ListResponse, PaginationState } from '../types'

interface getPromotionsParams extends PaginationState {
    coursePriceId: number
}

export const coursePromotionApi = createApi({
    reducerPath: 'coursePromotionApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['CoursePromotion'],
    endpoints: (build) => ({
        getPromotionsByCoursePrice: build.query<
            ListResponse<CoursePromotionState>,
            getPromotionsParams
        >({
            query: ({ coursePriceId, size, page }) => ({
                url: `course-promotion/${coursePriceId}`,
                params: {
                    size,
                    page,
                },
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result?.data?.map(({ id }) => ({
                              type: 'CoursePromotion' as const,
                              id,
                          })),
                          { type: 'CoursePromotion', id: 'LIST' },
                      ]
                    : [{ type: 'CoursePromotion', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<CoursePromotionState>
            }) => ({
                data: response?.data?.data,
                pageNumber: response?.data?.pageNumber,
                totalCount: response?.data?.totalCount,
                totalPages: response?.data?.totalPages,
            }),
        }),

        createCoursePromotion: build.mutation<void, CoursePromotionState>({
            query: (coursePromotion) => ({
                url: 'course-promotion',
                method: 'POST',
                body: coursePromotion,
            }),
            invalidatesTags: [{ type: 'CoursePromotion', id: 'LIST' }],
        }),

        updateCoursePromotion: build.mutation<void, CoursePromotionState>({
            query: (coursePromotion) => ({
                url: `course-promotion/${coursePromotion.id}`,
                method: 'PUT',
                body: coursePromotion,
            }),
            invalidatesTags: [{ type: 'CoursePromotion', id: 'LIST' }],
        }),

        deleteCoursePromotion: build.mutation<void, number>({
            query: (id) => ({
                url: `/course-promotion/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'CoursePromotion', id },
            ],
        }),
    }),
})
